/**
 * use to check user roles
 * @param {Array} requireRoles enum: user, admin
 * @param {String} userRole enum: user, admin
 * @return {Boolean}
 */
export const hasRole = (requireRoles, userRole) => requireRoles.includes(userRole);

/**
 * use to get menus that will display on the sidebar, depending on user roles
 * @param {Array} navigations ref from ./src/containers/_nav.js
 * @param {String} userRole enum: user, admin
 * @return {Array}
 */
export const getMenus = (navigations, userRole) => {
	return navigations.reduce((acc, item) => {
		const isNested = item._name === 'CSidebarNavDropdown';

		if (isNested) {
			const nestedItems = item.items.filter((nestedItem) => hasRole(nestedItem.requireRoles, userRole));

			if (nestedItems.length > 0) {
				acc.push({
					...item,
					items: nestedItems,
				});
			}
		} else if (hasRole(item.requireRoles, userRole)) {
			acc.push(item);
		}
		return acc;
	}, []);
};
